import { render, staticRenderFns } from "./SidebarToggle.vue?vue&type=template&id=12cf4d7e&scoped=true"
import script from "./SidebarToggle.vue?vue&type=script&lang=js"
export * from "./SidebarToggle.vue?vue&type=script&lang=js"
import style0 from "./SidebarToggle.vue?vue&type=style&index=0&id=12cf4d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cf4d7e",
  null
  
)

export default component.exports